import qs from 'qs';
import { APP } from 'config';

export const generateDynamicLink = ({
  path,
  params = {},
}: {
  path: string;
  params?: Record<string, string | number | boolean>;
}) => {
  return [
    new URL(APP.dynamicLinks.path, APP.dynamicLinks.baseUrl).href,
    qs.stringify(
      { params: JSON.stringify({ path, ...params }) },
      { addQueryPrefix: true, skipNulls: true, encodeValuesOnly: true },
    ),
  ].join('');
};
